// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_string = require("rescript/lib/js/js_string.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("./common/http.res.js");
var Image$ReactHooksTemplate = require("./common/image.res.js");
var Utils$ReactHooksTemplate = require("./common/utils.res.js");

function empty(param) {
  return {
          password: "",
          passwordConfirmation: "",
          resetPasswordToken: ""
        };
}

function setPassword(password, t) {
  return {
          password: password,
          passwordConfirmation: t.passwordConfirmation,
          resetPasswordToken: t.resetPasswordToken
        };
}

function setPasswordConfirmation(passwordConfirmation, t) {
  return {
          password: t.password,
          passwordConfirmation: passwordConfirmation,
          resetPasswordToken: t.resetPasswordToken
        };
}

function setToken(resetPasswordToken, t) {
  return {
          password: t.password,
          passwordConfirmation: t.passwordConfirmation,
          resetPasswordToken: resetPasswordToken
        };
}

function password(t) {
  return t.password;
}

function passwordConfirmation(t) {
  return t.passwordConfirmation;
}

function resetPasswordToken(t) {
  return t.resetPasswordToken;
}

var ResetPasswordParams = {
  empty: empty,
  setPassword: setPassword,
  setPasswordConfirmation: setPasswordConfirmation,
  setToken: setToken,
  password: password,
  passwordConfirmation: passwordConfirmation,
  resetPasswordToken: resetPasswordToken
};

function ResetPassword(props) {
  var token = props.token;
  var match = React.useState(function (param) {
        return {
                password: "",
                passwordConfirmation: "",
                resetPasswordToken: ""
              };
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = React.useState(function (param) {
        
      });
  var setError = match$1[1];
  var error = match$1[0];
  var match$2 = React.useState(function (param) {
        
      });
  var setSuccessMsg = match$2[1];
  var successMsg = match$2[0];
  React.useEffect((function (param) {
          Curry._1(setState, (function (state) {
                  return setToken(token, state);
                }));
        }), []);
  var isLengthValid = state.password.length >= 8;
  var match$3 = Js_string.match_(/[a-zA-Z]/, state.password);
  var hasAlphabet = match$3 !== undefined;
  var match$4 = Js_string.match_(/\d/, state.password);
  var hasNumber = match$4 !== undefined;
  var match$5 = Js_string.match_(/[^a-zA-Z0-9]/, state.password);
  var hasSpecialChar = match$5 !== undefined;
  var match$6 = state.password;
  var isStrongPassword = match$6 === "" || isLengthValid && hasAlphabet && hasNumber && hasSpecialChar ? undefined : Caml_option.some(JsxRuntime.jsx("p", {
              children: "Password not strong enough",
              className: "text-red-500 text-sm float-left pt-1"
            }));
  var x = state.passwordConfirmation;
  var isPasswordMatch = x === "" ? undefined : (
      x === state.password ? Caml_option.some(JsxRuntime.jsx("p", {
                  children: "Both passwords are a match",
                  className: "text-green-500 text-sm float-left pt-1"
                })) : Caml_option.some(JsxRuntime.jsx("p", {
                  children: "Passwords are not a match",
                  className: "text-red-500 text-sm float-left pt-1"
                }))
    );
  var handleFormInputChange = function ($$event) {
    var name = $$event.target.name;
    var value = $$event.target.value;
    switch (name) {
      case "user[password]" :
          return Curry._1(setState, (function (state) {
                        return setPassword(value, state);
                      }));
      case "user[password_confirmation]" :
          return Curry._1(setState, (function (state) {
                        return setPasswordConfirmation(value, state);
                      }));
      default:
        return ;
    }
  };
  var isFormValid = function (param) {
    if (state.password === "" || state.passwordConfirmation === "") {
      return false;
    } else {
      return state.password === state.passwordConfirmation;
    }
  };
  var buildTargetDict = function (state) {
    var params = {};
    var user = {};
    user["password"] = state.password;
    user["password_confirmation"] = state.passwordConfirmation;
    user["reset_password_token"] = state.resetPasswordToken;
    params["user"] = user;
    params["authenticity_token"] = Utils$ReactHooksTemplate.csrfToken;
    return params;
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("img", {
                            className: "h-full w-full object-cover",
                            src: Image$ReactHooksTemplate.signupOnboarding
                          }),
                      className: "w-1/2 max-h-full"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("img", {
                                            className: "h-40-px w-120-px",
                                            src: Image$ReactHooksTemplate.geckolystLogoWithText
                                          }),
                                      className: "flex items-center"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("button", {
                                              children: "Need help?",
                                              className: "text-sm text-darksilver hover:text-indigo-600 p-2"
                                            }),
                                        JsxRuntime.jsxs("button", {
                                              children: [
                                                JsxRuntime.jsx("img", {
                                                      src: Image$ReactHooksTemplate.headphone
                                                    }),
                                                JsxRuntime.jsx("div", {
                                                      children: "Contact Us",
                                                      className: "flex items-center h-full w-20"
                                                    })
                                              ],
                                              className: "rounded-lg text-darkcharcoal border border-gainsboro flex gap-2 p-2 font-medium text-sm"
                                            })
                                      ],
                                      className: "flex gap-2"
                                    })
                              ],
                              className: "flex justify-between w-full px-6 py-4 border-b border-platinum bg-white"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsxs("form", {
                                    children: [
                                      JsxRuntime.jsx("input", {
                                            name: "user[reset_password_token]",
                                            type: "hidden",
                                            value: token
                                          }),
                                      JsxRuntime.jsx("input", {
                                            name: "authenticity_token",
                                            type: "hidden",
                                            value: Utils$ReactHooksTemplate.csrfToken
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("p", {
                                                            children: "Enter your new password",
                                                            className: "text-darkcharcoal text-1xl font-medium px-5"
                                                          }),
                                                      error !== undefined ? JsxRuntime.jsx("div", {
                                                              children: error,
                                                              className: "text-red-500 text-sm mt-2"
                                                            }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                                                      successMsg !== undefined ? JsxRuntime.jsx("div", {
                                                              children: successMsg,
                                                              className: "text-green-500 text-sm mt-2"
                                                            }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                                                    ],
                                                    className: "text-center flex flex-col gap-2 w-1/2"
                                                  }),
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsxs("div", {
                                                            children: [
                                                              JsxRuntime.jsx("label", {
                                                                    children: "Password",
                                                                    className: "float-left text-darkcharcoal text-sm font-medium mb-1",
                                                                    name: "password"
                                                                  }),
                                                              JsxRuntime.jsx("input", {
                                                                    className: "rounded-lg bg-white w-full h-40-px text-sm font-normal pl-4 pr-3 py-3 focus:border focus:border-black",
                                                                    id: "user_password",
                                                                    autoComplete: "off",
                                                                    name: "user[password]",
                                                                    placeholder: "Type here",
                                                                    type: "password",
                                                                    value: state.password,
                                                                    onChange: handleFormInputChange
                                                                  }),
                                                              isStrongPassword !== undefined ? Caml_option.valFromOption(isStrongPassword) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                                                            ],
                                                            className: ""
                                                          }),
                                                      JsxRuntime.jsxs("div", {
                                                            children: [
                                                              JsxRuntime.jsx("label", {
                                                                    children: "Re-enter password",
                                                                    className: "float-left text-darkcharcoal text-sm font-medium mb-1",
                                                                    name: "password_confirmation"
                                                                  }),
                                                              JsxRuntime.jsx("input", {
                                                                    className: "rounded-lg bg-white w-full h-40-px text-sm font-normal pl-4 pr-3 py-3 focus:border focus:border-black",
                                                                    id: "user_password_confirmation",
                                                                    autoComplete: "off",
                                                                    name: "user[password_confirmation]",
                                                                    placeholder: "Type here",
                                                                    type: "password",
                                                                    value: state.passwordConfirmation,
                                                                    onChange: handleFormInputChange
                                                                  }),
                                                              isPasswordMatch !== undefined ? Caml_option.valFromOption(isPasswordMatch) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                                                            ],
                                                            className: ""
                                                          })
                                                    ],
                                                    className: "text-center flex flex-col gap-8 w-1/2 max-w-390-px"
                                                  }),
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("p", {
                                                            children: "Password must include",
                                                            className: "text-darksilver text-sm font-normal"
                                                          }),
                                                      JsxRuntime.jsxs("ul", {
                                                            children: [
                                                              JsxRuntime.jsxs("li", {
                                                                    children: [
                                                                      JsxRuntime.jsx("div", {
                                                                            children: isLengthValid ? JsxRuntime.jsx("img", {
                                                                                    src: Image$ReactHooksTemplate.greenCheckbox
                                                                                  }) : JsxRuntime.jsx("img", {
                                                                                    src: Image$ReactHooksTemplate.lightErrorIcon
                                                                                  })
                                                                          }),
                                                                      JsxRuntime.jsx("p", {
                                                                            children: "at least 8 characters",
                                                                            className: "text-darksilver text-sm font-normal"
                                                                          })
                                                                    ],
                                                                    className: "flex items-center space-x-3"
                                                                  }),
                                                              JsxRuntime.jsxs("li", {
                                                                    children: [
                                                                      JsxRuntime.jsx("div", {
                                                                            children: hasAlphabet ? JsxRuntime.jsx("img", {
                                                                                    src: Image$ReactHooksTemplate.greenCheckbox
                                                                                  }) : JsxRuntime.jsx("img", {
                                                                                    src: Image$ReactHooksTemplate.lightErrorIcon
                                                                                  })
                                                                          }),
                                                                      JsxRuntime.jsx("p", {
                                                                            children: "at least 1 alphabet",
                                                                            className: "text-darksilver text-sm font-normal"
                                                                          })
                                                                    ],
                                                                    className: "flex items-center space-x-3"
                                                                  }),
                                                              JsxRuntime.jsxs("li", {
                                                                    children: [
                                                                      JsxRuntime.jsx("div", {
                                                                            children: hasNumber ? JsxRuntime.jsx("img", {
                                                                                    src: Image$ReactHooksTemplate.greenCheckbox
                                                                                  }) : JsxRuntime.jsx("img", {
                                                                                    src: Image$ReactHooksTemplate.lightErrorIcon
                                                                                  })
                                                                          }),
                                                                      JsxRuntime.jsx("p", {
                                                                            children: "a number",
                                                                            className: "text-darksilver text-sm font-normal"
                                                                          })
                                                                    ],
                                                                    className: "flex items-center space-x-3"
                                                                  }),
                                                              JsxRuntime.jsxs("li", {
                                                                    children: [
                                                                      JsxRuntime.jsx("div", {
                                                                            children: hasSpecialChar ? JsxRuntime.jsx("img", {
                                                                                    src: Image$ReactHooksTemplate.greenCheckbox
                                                                                  }) : JsxRuntime.jsx("img", {
                                                                                    src: Image$ReactHooksTemplate.lightErrorIcon
                                                                                  })
                                                                          }),
                                                                      JsxRuntime.jsx("p", {
                                                                            children: "a special character",
                                                                            className: "text-darksilver text-sm font-normal"
                                                                          })
                                                                    ],
                                                                    className: "flex items-center space-x-3"
                                                                  })
                                                            ],
                                                            className: "space-y-3"
                                                          })
                                                    ],
                                                    className: "flex flex-col gap-6 w-1/2 max-w-390-px"
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx("div", {
                                                          children: JsxRuntime.jsx("input", {
                                                                className: "py-10-px px-30-px rounded-lg w-full " + (
                                                                  isFormValid() ? "bg-black text-ufogreen cursor-pointer" : "disabled-input bg-lightgray text-white"
                                                                ),
                                                                disabled: !isFormValid(),
                                                                name: "commit",
                                                                type: "submit",
                                                                value: "Save and Continue"
                                                              }),
                                                          className: "w-full"
                                                        }),
                                                    className: "flex items-center w-1/2  max-w-390-px"
                                                  })
                                            ],
                                            className: "flex items-center justify-center flex-col gap-8"
                                          })
                                    ],
                                    className: "w-full justify-center",
                                    autoComplete: "off",
                                    charSet: "UTF-8",
                                    onSubmit: (function ($$event) {
                                        $$event.preventDefault();
                                        Js_promise.then_((function (response) {
                                                var status = Json_decode.field("status", (function (param) {
                                                        return Json_decode.withDefault("failed", Json_decode.string, param);
                                                      }), response);
                                                if (status === "success") {
                                                  Curry._1(setSuccessMsg, (function (param) {
                                                          return "Password updated successfully";
                                                        }));
                                                  Curry._1(setError, (function (param) {
                                                          
                                                        }));
                                                  setTimeout((function (param) {
                                                          RescriptReactRouter.push("/users/sign_in");
                                                          window.location.reload();
                                                        }), 1500);
                                                } else {
                                                  var error = Json_decode.field("errors", Json_decode.string, response);
                                                  Curry._1(setError, (function (param) {
                                                          return error;
                                                        }));
                                                  Curry._1(setSuccessMsg, (function (param) {
                                                          
                                                        }));
                                                }
                                                return Promise.resolve();
                                              }), Http$ReactHooksTemplate.fetchPostJSON("/users/password/update", buildTargetDict(state)));
                                      })
                                  }),
                              className: "flex items-center justify-center w-full h-4/5"
                            })
                      ],
                      className: "w-1/2 max-h-full bg-ghostwhiteblue"
                    })
              ],
              className: "flex h-full"
            });
}

var make = ResetPassword;

exports.ResetPasswordParams = ResetPasswordParams;
exports.make = make;
/* react Not a pure module */
